<template>
    <div class="allura-input allura-input--text" :class="{'allura-input--error': this.hasError}">
        <div class="allura-input__label-wrapper">
            <div v-if="label">
                <label :for="id">{{label}}</label>
            </div>
            <div>
                <input v-model="content"
                       @input="signalChange"
                       type="text"
                       :id="id"
                       :placeholder="placeholder"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: String,
            placeholder: String,
            label: String,
            name: String,
            id: String,
            hasError: Boolean
        },
        data() {
            return {
                content: this.value
            }
        },
        methods: {
            signalChange(e) {
                this.$emit('input', this.content);
            }
        }
    }
</script>